import styled from 'styled-components';
import { Panel } from './styles';

// 沿用帳戶內頁的白底、品牌藍與18px基準；不重做共用頁首或側欄。
export const SubscriptionSurface = styled.div`
  min-width: 0;
  color: #242b3a;
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;
  p, h2, h3, dt, dd, a {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .status {
    box-sizing: border-box;
    max-width: 100%;
    overflow-wrap: anywhere;
  }
  .actions > * {
    min-width: 0;
    max-width: 100%;
  }
  button {
    max-width: 100%;
    height: auto;
    min-height: 44px;
    white-space: normal;
    line-height: 1.5;
  }
  .intro {
    color: #596579;
    margin: 0 0 24px;
  }
  .section-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }
  .section-heading h2 {
    margin-bottom: 4px;
  }
  .muted {
    color: #596579;
  }
  .number {
    font-variant-numeric: tabular-nums;
  }
  a {
    color: ${(p) => p.theme.colors.primary500};
    text-underline-offset: 4px;
  }
  a:hover {
    text-decoration: underline;
  }
  a:focus-visible,
  button:focus-visible,
  summary:focus-visible,
  .table-scroll:focus-visible {
    outline: 3px solid #0b319d;
    outline-offset: 4px;
  }
  .action-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    white-space: normal;
    overflow-wrap: anywhere;
    padding: 8px 18px;
    border: 1px solid #0b319d;
    border-radius: 5px;
    text-decoration: none;
    font: inherit;
    font-weight: 600;
    cursor: pointer;
    background: white;
    color: #0b319d;
  }
  .action-link[aria-pressed='true'] {
    background: #0b319d;
    color: white;
  }
  .action-link.primary {
    background: #0b319d;
    color: white;
  }
  .action-link:hover {
    background: #eef3ff;
  }
  .action-link.primary:hover {
    background: #082779;
  }
  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .notice {
    border-left: 3px solid #0b319d;
    background: #f5f7fc;
    padding: 12px 16px;
  }
  h2,
  h3 {
    text-wrap: balance;
  }
  table {
    font-variant-numeric: tabular-nums;
  }
  th {
    background: #f5f7fc;
    color: #344158;
    font-weight: 600;
  }
  th,
  td {
    overflow-wrap: anywhere;
  }
  summary {
    min-height: 44px;
    display: list-item;
    padding: 8px 0;
    color: #0b319d;
  }
  /* 每項服務與其「來源與效期」視為同一列，避免一項服務佔兩條分隔線。 */
  tbody .usage-row > th,
  tbody .usage-row > td {
    background: transparent;
    border-bottom: 0;
    padding-bottom: 0;
  }
  tbody .source-row > td {
    padding-top: 0;
    padding-bottom: 4px;
  }
  .source-row summary {
    min-height: 36px;
    padding: 4px 0;
    font-size: ${(p) => p.theme.fontSizes.sm};
  }
  .table-scroll {
    overflow-x: auto;
    max-width: 100%;
  }
  .table-scroll > table {
    min-width: 650px;
  }
  .source-table {
    background: #f8faff;
    padding: 16px;
    margin: 8px 0 16px;
  }
  .source-table table {
    min-width: 480px;
  }
  .source-table th {
    background: #eaf0fa;
  }
  .empty {
    padding: 16px 0;
    color: #596579;
  }
  .section-links {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    padding-bottom: 16px;
  }
  .section-links a {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }
  .package-row {
    display: grid;
    /* 每列各自為 grid，欄寬須固定才能讓價格、到期與操作上下對齊。 */
    grid-template-columns: minmax(180px, 2fr) minmax(110px, 1fr) minmax(160px, 1.4fr) 180px;
    align-items: center;
    gap: 20px;
    border-top: 1px solid #e1e5ec;
    padding: 18px 0;
  }
  .package-row p {
    margin: 4px 0;
  }
  .package-row .reason {
    grid-column: 1 / -1;
    margin: -8px 0 0;
    color: #596579;
  }
  .package-row .disabled {
    color: #596579;
    text-align: right;
  }
  .package-row .action-link {
    justify-self: end;
  }
  .table-hint {
    display: none;
  }
  @media (max-width: 700px) {
    .table-hint {
      display: block;
      color: #596579;
    }
    summary {
      max-width: calc(100vw - 100px);
      overflow-wrap: anywhere;
    }
    .package-row {
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 12px;
    }
    .package-row .expiry {
      grid-column: 1 / -1;
    }
    .package-row .action-link,
    .package-row .disabled {
      grid-column: 1 / -1;
      justify-self: stretch;
      text-align: left;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    scroll-behavior: auto;
  }
`;

export const PlanSummary = styled(Panel)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  border: 1px solid #e1e5ec;
  h2 {
    color: #182d58;
    margin: 0;
    font-size: 28px;
  }
  p {
    margin: 6px 0;
  }
  .plan-name {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }
  .state {
    color: #2c621e;
    background: #edf6e7;
    border-radius: 4px;
    padding: 2px 10px;
    font-size: 16px;
  }
  .plan-price {
    color: #182d58;
    font-size: 22px;
    font-weight: 600;
  }
  .plan-price small {
    font-size: 18px;
    font-weight: 400;
    color: #596579;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PlanRail = styled.section`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  background: white;
  border: 1px solid #e1e5ec;
  border-radius: 8px;
  margin-bottom: 24px;
  article {
    display: flex;
    flex-direction: column;
    padding: 20px 16px;
    border-right: 1px solid #e1e5ec;
    min-width: 0;
  }
  article:last-child {
    border-right: 0;
  }
  article[aria-current='true'] {
    background: #f2f6ff;
    box-shadow: inset 0 3px #0b319d;
  }
  h3 {
    font-size: 18px;
    color: #182d58;
    margin: 0 0 8px;
  }
  p {
    margin: 8px 0;
  }
  .price {
    font-weight: 700;
    color: #182d58;
    font-size: 22px;
  }
  .audience {
    color: #596579;
    min-height: 58px;
  }
  a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    margin-top: auto;
  }
  .current {
    font-weight: 600;
    color: #0b319d;
  }
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    article {
      border-bottom: 1px solid #e1e5ec;
    }
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    article {
      border-right: 0;
    }
    .audience {
      min-height: 0;
    }
  }
`;
